import { GoogleMapContext } from "#/context/GoogleMapContext";
import { useContext } from "react";

export const useGoogleMap = () => {
  return useContext(GoogleMapContext);
};
